import React, { VFC } from 'react'
import { XmlEntities } from 'html-entities'
import Link from 'next/link'
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { sortKanaDesc } from '@libs/sortKanaDesc'
import { IssueCategoryFragment } from '@services/graphcms/client'

type Props = {
  issues: IssueCategoryFragment['issues']
}

export const IssueTable: VFC<Props> = (props) => {
  if (!Array.isArray(props.issues) || props.issues.length <= 0) {
    return null
  }

  return (
    <TableContainer component={Box} pt={2} pl={8} pr={8}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell width="20%">トラブル名</TableCell>
            <TableCell width="60%">トラブル内容</TableCell>
            <TableCell width="20%"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.issues.sort(sortKanaDesc('titleKana')).map((issue) => (
            <TableRow key={issue.id}>
              <TableCell>{issue.title}</TableCell>
              <TableCell>
                <Box>
                  {
                    <div
                      dangerouslySetInnerHTML={{
                        __html: XmlEntities.decode(issue.problem.html),
                      }}
                    />
                  }
                  <Box display="flex">
                    <Typography variant="caption">キーワード：</Typography>
                    {issue.keywords.map((keyword, index) => (
                      <Typography key={keyword} variant="caption">{`${keyword}${
                        issue.keywords.length > index + 1 ? '・' : ''
                      }`}</Typography>
                    ))}
                  </Box>
                </Box>
              </TableCell>
              <TableCell>
                <Link href={`/issue/${issue.id}`}>
                  <a>
                    <Typography>対策を確認</Typography>
                  </a>
                </Link>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
